import React, { useState, useRef } from "react";
import AboutBannerImage1 from "../../src/assets/images/aboutbanner1.png";
import AboutBannerImage2 from "../../src/assets/images/aboutbanner2.jpeg";
import AboutBannerImage3 from "../../src/assets/images/dna1.png";
import CustomLine from "./CustomLine";
import AboutImage1 from "../../src/assets/images/image_40.png";
import AboutImage2 from "../../src/assets/images/image_41.png";
import AppoinmentModal from "./AppoinmnetModal";
import { useNavigate } from 'react-router-dom';

const AboutBanner = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const stickyButtonRef = useRef(null);

    const navigate = useNavigate();

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleContactClick = () => {
        navigate('/contact');
    };

    const handleGetStartedClick = () => {
        navigate('/register');
    };

    return (
        <div className="custom-science">
            <div className="custom-padding xl-screen-padding flex gap-10 flex-col md:flex-row w-full min-h-screen bg-white">
                <div className="w-full md:w-1/2 flex flex-col justify-center aboutmain">
                    <p className="custom-padding-bottom text-[#7C517E] text-md sm:text-md font-lato block sm:flex items-center slide-left">
                        <CustomLine />
                        <span className="ml-0 sm:ml-2 text-p">About Nutrillion</span>
                    </p>
                    <h2 className="custom-padding-bottom text-lg sm:text-xl custom-line-height md:text-xl lg:text-4xl font-semibold text-black leading-tight client-text">
                        Health made personal
                        <br />
                        Just for you
                    </h2>
                    <p className="border-t-2 border-[#8f762c] mb-6"></p>
                    <p className="mb-6 text-[#656565] text-p">
                        Nourish your body, the personalized way
                    </p>
                    <p className="text-[#939a9e] mb-6 text-p">
                        A great health is the foundation of a great life, providing the energy and clarity to pursue
                        your passions and enjoy every moment. At Nutrillion, we believe personalized nutrition can transform lives, empowering you to live your best life with a smile.
                    </p>
                    <div className="flex flex-row space-x-3 items-center">
                        <button 
                            onClick={handleGetStartedClick}
                            className="bg-gray-800 common-btn-all-second text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-auto"
                        >
                            Get Started
                        </button>
                        <button
                            className="bg-[#8f762c] common-btn-all text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-auto"
                            onClick={handleContactClick}
                        >
                            Contact Us
                        </button>
                        <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
                    </div>
                </div>

                <div className="w-full md:w-1/2 flex flex-col items-center justify-center">
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div className="relative rounded-lg overflow-hidden">
                            <img src={AboutBannerImage1} alt="Tailored diet" className="w-full h-full object-cover" />
                            <div className="absolute top-2 sm:top-6 md:top-10 custom-about-image left-1/4 sm:left-1/3 md:left-1/4 transform -translate-x-1/2">
                                <img src={require("../../src/assets/images/ICON.png")} alt="Icon" className="w-24 h-24 iconabout" />
                            </div>
                            <div className="absolute bottom-0 left-0 right-0 text-center p-4">
                                <p className="text-white text-sm font-semibold textabout">
                                    Tailoring your dietary regime based on your unique DNA
                                </p>
                            </div>
                        </div>

                        <div className="relative rounded-lg overflow-hidden">
                            <img src={AboutBannerImage2} alt="Personalized roadmap" className="w-full h-full object-cover" />
                            <div className="absolute bottom-0 left-0 right-0 text-center p-4">
                                <p className="text-white text-sm font-semibold textabout">
                                    Personalized 6-month roadmap, your long term health goals.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="relative rounded-lg overflow-hidden">
                        <img src={AboutBannerImage3} alt="Nutrigenomics" className="w-full h-full object-cover" />
                        <div className="absolute bottom-0 left-0 right-0 text-center p-4">
                            <p className="text-white text-sm font-semibold textabout">
                                Designing personalized nutrition plans by leveraging cutting edge Nutrigenomics and Gut Microbiome Analysis
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <button
                    ref={stickyButtonRef}
                    type="button"
                    className="sticky-button bg-[#7c517e] text-white text-sm px-3 py-1 md:px-4 md:py-2 mt-2 md:mt-0 w-full cursor-pointer md:w-auto"
                    onClick={openModal}
                >
                    BOOK APPOINTMENT
                </button>

                <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
            </div>
            <div className="custom-padding xl-screen-padding flex pt-80 pb-80 flex-col gap-10 md:flex-row w-full h-auto bg-[#f2f0ed] rounded-lg">
                <div className="w-full md:w-8/12 flex flex-col justify-center rounded-lg">
                    <h2 className="text-2xl md:text-4xl text-gray-900 mb-4 font-merriweather science">
                        <span className="text-[#8f762c]">Science</span> Meets <span className="text-[#8f762c]">Sustainability</span>,
                        <br /> Our Approach for a Better You
                    </h2>
                    <p className="text-[#6f787e] mb-6 text-sm text-p md:text-base">
                        We, at Nutrillion, a brand of Nutrivison Wellness & Genetics Private Limited, are focused on our approach to science and sustainability. By leveraging cutting-edge Nutrigenomics and gut microbiome analysis, we design personalized nutrition plans tailored to your unique body and health needs, unlike traditional nutrition plans focused solely on weight loss or generic diets.
                    </p>
                    <p className="text-[#6f787e] text-sm text-p md:text-base">
                        Our mission is to support individuals facing health challenges—be it chronic conditions or lifestyle-related issues—through personalized support tailored to their medical history and personal goals. Every person is different, so we don't offer one-size-fits-all solutions. Instead, we start with comprehensive testing, pre-nutritional counselling, complete with weekly nutritional plans and ongoing support to ensure consistency and high success rate.
                    </p>
                </div>

                <div className="w-full md:w-4/12 flex flex-col items-center justify-center md:items-end relative">
                    <div className="w-[100%] rounded-[40px] sm:w-[60%] md:w-[80%] h-auto overflow-hidden">
                        <img src={AboutImage1} alt="Tailored diet" className="w-full h-full object-cover" />
                    </div>
                    <div className="w-[70%] rounded-[40px] sm:w-[20%] md:w-[60%] h-auto overflow-hidden absolute top-3/4 left-[0%] transform md:translate-y-[-150px] -translate-y-2/3 hidden md:block second-image">
                        <img src={AboutImage2} alt="Tailored diet" className="w-full h-full object-cover" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutBanner;